import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=3abec42e&scoped=true&lang=pug"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"
import style1 from "./ProjectCard.vue?vue&type=style&index=1&id=3abec42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abec42e",
  null
  
)

export default component.exports